import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent, CopyToClipboardComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'self-service-customer-promotion',
  templateUrl: './customer-promotion.component.html',
  imports: [RouterLink, CopyToClipboardComponent, TranslocoPipe, ButtonComponent],
})
export class CustomerPromotionComponent {
  @Input() public bonus?: string;
  @Input() public loggedIn: boolean;
  @Input() public promoLink: string;
  @Input() public notYetCustomerMessage = false;

  public showPromoCode = false;

  public readonly commonRoutes = commonRoutes;
}
